import React from 'react';

// 신뢰도 뱃지 — API의 trustBadge 객체 { level, label, icon, color }를 pill로 렌더
function TrustBadge(props){
  var badge=props.badge;
  var size=props.size||'sm'; // sm | md | lg
  if(!badge||!badge.level)return null;
  var isWarning=badge.level==='warning';
  var fontSize=size==='lg'?13:size==='md'?12:11;
  var padY=size==='lg'?4:3;
  var padX=size==='lg'?10:8;
  var baseColor=badge.color||'#64748b';
  var bg=isWarning?'rgba(239,68,68,0.12)':baseColor+'22';
  var border=isWarning?'1px solid #ef4444':'1px solid '+baseColor+'55';
  var color=isWarning?'#dc2626':baseColor;
  return (
    <span style={{display:'inline-flex',alignItems:'center',gap:4,padding:padY+'px '+padX+'px',borderRadius:9999,background:bg,border:border,color:color,fontSize:fontSize,fontWeight:700,whiteSpace:'nowrap',lineHeight:1}}>
      <span style={{fontSize:fontSize}}>{badge.icon||'🌱'}</span>
      <span>{badge.label||'신규'}</span>
    </span>
  );
}

export default TrustBadge;
